module.exports = __webpack_public_path__ + "img/main-pic.46c0d2b7.png";